<template>
  <div
    v-if="item"
    class="text-no-wrap"
  >
    <span v-if="item.DisplayType ==='checkbox'">
      <v-icon
        v-if="!hideIcon"
        :class="{'mr-2': !hideLabel}"
        :small="dense"
      >{{ $t('Restaurant.Options.ListView.ChoiceType.Multiple.Icon') }}</v-icon>
      <span v-if="!hideLabel">{{ getTranslatedField(types?.find(t => t.Id === item.DisplayType), 'Name') }}</span>
    </span>
    <span v-else-if="item.DisplayType === 'radio'">
      <v-icon
        v-if="!hideIcon"
        :class="{'mr-2': !hideLabel}"
        :small="dense"
      >{{ $t('Restaurant.Options.ListView.ChoiceType.Single.Icon') }}</v-icon>
      <span v-if="!hideLabel">{{ getTranslatedField(types?.find(t => t.Id === item.DisplayType), 'Name') }}</span>
    </span>
    <span v-else-if="item.DisplayType === 'unit'">
      <v-icon
        v-if="!hideIcon"
        :class="{'mr-2': !hideLabel}"
        :small="dense"
      >{{ $t('Restaurant.Options.ListView.ChoiceType.Unit.Icon') }}</v-icon>
      <span v-if="!hideLabel">{{ getTranslatedField(types?.find(t => t.Id === item.DisplayType), 'Name') }}</span>
    </span>
    <span v-else-if="item.DisplayType === 'unit_value'">
      <v-icon
        v-if="!hideIcon"
        :class="{'mr-2': !hideLabel}"
        :small="dense"
      >{{ $t('Restaurant.Options.ListView.ChoiceType.UnitValue.Icon') }}</v-icon>
      <span v-if="!hideLabel">{{ getTranslatedField(types?.find(t => t.Id === item.DisplayType), 'Name') }}</span>
    </span>
    <span v-else-if="item.DisplayType === 'extra_charges'">
      <v-icon
        v-if="!hideIcon"
        :class="{'mr-2': !hideLabel}"
        :small="dense"
      >{{ $t('Restaurant.Options.ListView.ChoiceType.ExtraCharges.Icon') }}</v-icon>
      <span v-if="!hideLabel">{{ getTranslatedField(types?.find(t => t.Id === item.DisplayType), 'Name') }}</span>
    </span>
    <span v-else-if="item.DisplayType === 'label'">
      <v-icon
        v-if="!hideIcon"
        :class="{'mr-2': !hideLabel}"
        :small="dense"
      >{{ $t('Restaurant.Options.ListView.ChoiceType.Label.Icon') }}</v-icon>
      <span v-if="!hideLabel">{{ getTranslatedField(types?.find(t => t.Id === item.DisplayType), 'Name') }}</span>
    </span>
    <span v-else-if="item.DisplayType === 'separator'">
      <v-icon
        v-if="!hideIcon"
        :class="{'mr-2': !hideLabel}"
        :small="dense"
      >{{ $t('Restaurant.Options.ListView.ChoiceType.Separator.Icon') }}</v-icon>
      <span v-if="!hideLabel">{{ getTranslatedField(types?.find(t => t.Id === item.DisplayType), 'Name') }}</span>
    </span>
    <template v-else>
      {{ item.DisplayType }}
    </template>
  </div>
</template>

<script>

import Translatable from '@/mixins/translatable.js'

export default {
  name      : 'OptionType',
  components: {},
  directives: {},
  mixins    : [Translatable],
  props     : {
    hideIcon: {
      type   : Boolean,
      default: false
    },
    hideLabel: {
      type   : Boolean,
      default: false
    },
    dense: {
      type   : Boolean,
      default: false
    },
    item: {
      type   : Object,
      default: undefined
    },
    types: {
      type   : Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
